import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    cell: {
      padding: theme.spacing(0, 1, 0, 1),
      '&:first-of-type': { paddingLeft: theme.spacing(2) },
      '&:last-of-type': { paddingRight: theme.spacing(2) },
      borderBottom: 'none',
    },
    row: {
      cursor: 'pointer',
    },
  };
};
